import { getNativeReaderHref } from 'helpers/nativeReaderHref'
import { useRouter } from 'next/router'

/** Resolves reader links during rendering and again when a native bridge arrives late. */
export function useNativeReaderLink() {
  const router = useRouter()

  /** Supplies Next Link props that enter the native reader before reading starts. */
  return function getReaderLinkProps(href: string) {
    const renderedHref = getNativeReaderHref(href)

    return {
      href: renderedHref,
      /** Rechecks the bridge at navigation time without changing ordinary browser links. */
      onNavigate(event: { preventDefault: () => void }) {
        const currentHref = getNativeReaderHref(href)
        if (currentHref === renderedHref) return
        event.preventDefault()
        void router.push(currentHref)
      },
    }
  }
}
